import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { formatDateID, formatTimeID } from "@/lib/format";
import { ChevronLeft, Bell, Package, Wallet, Tag, Info } from "lucide-react";

const ICONS = { order: Package, payment: Wallet, promo: Tag, info: Info };

export default function StoreNotifications() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (user) {
      api.get("/notifications").then((r) => {
        setData(r.data);
        api.post("/notifications/read-all").catch(() => {});
      }).catch(() => setData({ items: [], unread: 0 }));
    }
  }, [user]);

  if (!user) {
    return (
      <div className="text-center py-16">
        <Bell className="w-12 h-12 text-cocoa-muted mx-auto mb-3" />
        <div className="text-sm text-cocoa-muted mb-4">Masuk untuk melihat notifikasi</div>
        <Link to="/store/auth" className="px-6 h-11 leading-[44px] inline-block rounded-full bg-brand text-white text-sm font-semibold">Masuk</Link>
      </div>
    );
  }

  return (
    <div className="space-y-3 animate-fade-up">
      <div className="flex items-center justify-between">
        <button onClick={() => nav(-1)} className="w-9 h-9 rounded-full bg-white border border-blush-soft flex items-center justify-center">
          <ChevronLeft className="w-5 h-5" />
        </button>
        <h1 className="font-semibold">Notifikasi</h1>
        <div className="w-9" />
      </div>

      {data === null && <div className="text-center py-10 text-sm text-cocoa-muted">Memuat...</div>}
      {data?.items?.length === 0 && (
        <div className="text-center py-14 bg-white rounded-2xl border border-blush-soft">
          <Bell className="w-10 h-10 text-cocoa-muted mx-auto mb-2" />
          <div className="text-sm text-cocoa-muted">Belum ada notifikasi.</div>
        </div>
      )}
      {data?.items?.map((n) => {
        const Icon = ICONS[n.type] || Info;
        const inner = (
          <div className={`flex gap-3 bg-white rounded-2xl border p-3.5 ${n.read ? "border-blush-soft" : "border-brand"}`}>
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${n.read ? "bg-blush" : "bg-brand"}`}>
              <Icon className={`w-5 h-5 ${n.read ? "text-brand" : "text-white"}`} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold">{n.title}</div>
              <div className="text-xs text-cocoa-muted mt-0.5 leading-relaxed">{n.body}</div>
              <div className="text-[10px] text-cocoa-muted mt-1">{formatDateID(n.created_at)} • {formatTimeID(n.created_at)}</div>
            </div>
          </div>
        );
        return n.link
          ? <Link key={n.id} to={n.link} data-testid={`notif-${n.id}`}>{inner}</Link>
          : <div key={n.id} data-testid={`notif-${n.id}`}>{inner}</div>;
      })}
    </div>
  );
}
